<div style="margin-top: -300px;">
  <div class="d-flex align-items-center" style="position:absolute; top: 44%; left: 44%;">
    <p class="w-100 text-center h1 app-primary-text-color">COMING SOON...</p>
  </div>
</div>

